import { useEffect, useState } from 'react';

import styled from 'styled-components';

import { Button, ButtonGroup, CheckBox, Modal, Text } from '@sine/sine-ui-components';

import { getStoredData, setStoredData } from '../../../../services/storage/storage.service';
import { HIDE_CONFIRM_INVITATION_STORE_KEY } from '../../invitations.constants';

const StyledCheckBox = styled(CheckBox)`
  padding: 0;
  margin: 0;

  span {
    min-height: 0;
  }
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Statement = styled(Text)`
  word-break: keep-all;
`;

interface ConfirmInvitationModalProps {
  numberOfGuestsWithoutEmail: number;
  onCreateInvitations: VoidFunction;
  onClose: VoidFunction;
  loadingSubmission: boolean;
}

export function ConfirmInvitationModal({
  numberOfGuestsWithoutEmail,
  onCreateInvitations,
  onClose,
  loadingSubmission,
}: ConfirmInvitationModalProps) {
  const [hideConfirmInvitationModal, setHideConfirmInvitationModal] = useState(
    getStoredData(HIDE_CONFIRM_INVITATION_STORE_KEY),
  );

  useEffect(() => {
    if (getStoredData(HIDE_CONFIRM_INVITATION_STORE_KEY) !== hideConfirmInvitationModal) {
      setStoredData(HIDE_CONFIRM_INVITATION_STORE_KEY, hideConfirmInvitationModal);
    }
  }, [hideConfirmInvitationModal]);

  return (
    <Modal
      show
      header='Confirm Invitation'
      footer={
        <FooterContainer>
          <StyledCheckBox
            value={hideConfirmInvitationModal}
            label="Don't ask me again"
            data-st-ext='checkbox-dont-ask-again'
            onClick={() => setHideConfirmInvitationModal(!getStoredData(HIDE_CONFIRM_INVITATION_STORE_KEY))}
          ></StyledCheckBox>
          <ButtonGroup>
            <Button variant='tertiary' onClick={onClose} data-st-ext='button-cancel'>
              Cancel
            </Button>
            <Button
              variant='primary'
              onClick={onCreateInvitations}
              data-st-ext='button-create-invitation'
              loading={loadingSubmission}
            >
              Create invitations
            </Button>
          </ButtonGroup>
        </FooterContainer>
      }
    >
      <Statement data-st-ext='confirmation-statement'>
        {
          <>
            You haven’t provided email addresses for{' '}
            <b data-st-ext='confirmation-guest-number'>
              {numberOfGuestsWithoutEmail} {numberOfGuestsWithoutEmail > 1 ? 'guests' : 'guest'}
            </b>
            . Invitations for these guests will be created in your Sine account, but we won’t send them an email
            notification. <br></br>
            <br></br>
            <p>Would you like to continue?</p>
          </>
        }
      </Statement>
    </Modal>
  );
}
